import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=dea12ade"
import script from "./Property.vue?vue&type=script&lang=js"
export * from "./Property.vue?vue&type=script&lang=js"
import style0 from "./Property.vue?vue&type=style&index=0&id=dea12ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports